import * as React from 'react';

import './select.css';

import { InputHighlight, SelectProps } from '../../types';

class Select extends React.Component<SelectProps> {
  public render() {
    const optionsClassName = `generic-select-option ${this.props.optionsClassName}`.trim();
    const options = this.props.options.map(
        option => <option className={optionsClassName} key={option}>{option}</option>
    );

    if (!this.props.defaultFirstOption) {
      options.unshift(
        <option className={`${optionsClassName} empty-option`} key="default-empty" disabled={true} value="">-- Select --</option>
      );
    }

    let highlightClassName = '';
    switch (this.props.highlight) {
      case InputHighlight.CORRECT:
        highlightClassName = 'is-correct'
        break;
      case InputHighlight.DANGER:
        highlightClassName = 'is-danger'
        break;
    }

    return (
      <div className={`field generic-select-wrapper ${this.props.layoutClassName}`.trim()}>
        {this.props.label && <label className="field-label generic-select-label">{this.props.label}</label>}
        <div className="field-body control generic-select-control">
          <div className={`select generic-select ${highlightClassName}`.trim()}>
            <select
                className={this.props.selectClassName}
                defaultValue={this.props.defaultValue}
                onChange={this.props.onChange}
                value={this.props.value}
            >
              {...options}
            </select>
          </div>
        </div>
        {this.props.helpMessage && <p className={`help ${highlightClassName}`}>{this.props.helpMessage}</p>}
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/common/forms/select.tsx